import React from "react";

const Input = ({ placeholder, value, changeHandler }) => {
  return (
    <input
      className="join_room_input"
      value={value}
      placeholder={placeholder}
      onChange={changeHandler}
    />
  );
};

const JoinRoomInputs = (props) => {
  const { roomIdValue, setRoomIdValue, nameValue, setNameValue, isRoomHost } =
    props;

  const handleRoomIdValueChange = (event) => {
    setRoomIdValue(event.target.value);
  };

  const handleNameValueChange = (event) => {
    setNameValue(event.target.value);
  };
  return (
    <div className="join_room_input_container">
      {!isRoomHost && (
        <Input
          placeholder="Enter Meeting Id"
          value={roomIdValue}
          changeHandler={handleRoomIdValueChange}
        />
      )}
      <Input
        placeholder="Enter Name"
        value={nameValue}
        changeHandler={handleNameValueChange}
      />
    </div>
  );
};

export default JoinRoomInputs;
